
import Vue, { PropType } from 'vue';

import { CvRadioGroup, CvRadioButton, CvButton } from '@carbon/vue';
import PrintTechniqueHeader from './PrintTechniqueHeader.vue';
import { ProductPrintPositionAddModel } from '@/typings';
import { LocaleMessage } from 'vue-i18n';

export default Vue.extend({
  name: 'PrintTechnique',
  components: {
    PrintTechniqueHeader,
    CvRadioGroup,
    CvRadioButton,
    CvButton,
  },
  props: {
    positionId: {
      type: String,
      required: true,
    },
    positionName: {
      type: String,
      required: true,
    },
    positionDimensions: {
      type: Object as PropType<{ width: number; height: number }>,
      required: true,
    },
    enabled: {
      type: Boolean,
      default: true,
    },
    /**
     * This concrete print position's model value
     */
    value: {
      type: Object,
      default: () => ({
        positionId: null,
        positionName: 'uninitialised',
        technique: { id: null },
      }),
    },
    /**
     * This concrete print postion's specific options
     */
    options: {
      type: Array,
      required: true,
    },
  },

  computed: {
    dimensions(): string {
      const { height, width } = this.positionDimensions;
      return `${width}mm x ${height}mm`;
    },
  },

  methods: {
    getMaximumColoursRepresentation(
      numColours: number,
      isFullColor: boolean
    ): string | LocaleMessage {
      return isFullColor
        ? this.$t('print-position.full-colour')
        : this.$t(`print-position.max-colours`) + `: ${numColours}`;
    },
    onResetOptions(option: any) {
      if (!this.value.positionId) return;
      this.$emit('clear-selection', {
        ...this.value,
        positionId: this.positionId,
        positionName: this.positionName,
        printPositionSAPCode: this.positionName,
        maxHeightMm: this.positionDimensions.height,
        maxWidthMm: this.positionDimensions.width,
        technique: {
          id: option.id,
          techniqueName: option.techniqueName,
          printTechniqueSAPCode: option.printTechniqueSAPCode,
          groupCode: option.groupCode,
        },
      });
    },
    onOptionChange(option: any) {
      this.$emit('input', {
        ...this.value,
        positionId: this.positionId,
        positionName: this.positionName,
        printPositionSAPCode: this.positionName,
        maxHeightMm: this.positionDimensions.height,
        maxWidthMm: this.positionDimensions.width,
        technique: {
          id: option.id,
          techniqueName: option.techniqueName,
          printTechniqueSAPCode: option.printTechniqueSAPCode,
          groupCode: option.groupCode,
        },
      });
    },
  },
});
